// extracted by mini-css-extract-plugin
export var backgroundWhite = "styles-module--backgroundWhite--D4oKy";
export var mediaContainer = "styles-module--mediaContainer--rVDGW";
export var content = "styles-module--content--MqU7T";
export var title = "styles-module--title--lDgWN";
export var description = "styles-module--description--SC2tO";